<div class="bid-confirmation-container">
  <nb-icon icon="close-outline" class="float-right close-button" (click)="cancel()"></nb-icon>

  <h6>Confirm Your Bid</h6>

  <p>Are you sure you want to place a bid of <strong>${{ bidAmount }}</strong> on this lot?</p>

  <p><strong>Lot {{lot.lotNum}}: {{lot.title}}</strong></p>

  <div class="button-container">
    <button nbButton size="medium" shape="round" status="basic" (click)="confirm()">Confirm Bid</button>
    <a class="back-link-text ml-2" (click)="cancel()">Cancel</a>
  </div>
</div>

